import { normalize, schema } from 'normalizr';
import { IState, ActionTypes } from './type';

const habitUserSchema = new schema.Entity('habitusers');
const habitUserListSchema = [habitUserSchema];

const initial: IState = {
  entities: {},
  ids: [],
  count: 0,
  loading: false,
};

const reducer = (state: IState = initial, action: any) => {
  switch (action.type) {
    case ActionTypes.REQUEST:
      return {
        ...state,
        loading: true
      };

    case ActionTypes.SUCCESS: {
      const normalizedData = normalize(action.payload.results, habitUserListSchema);

      return {
        ...state,
        entities: {
          ...state.entities,
          ...normalizedData.entities.habitusers,
        },
        ids: normalizedData.result as string[],
        count: action.payload.count as number,
        loading: false
      };
    }

    case ActionTypes.SUCCESS_SINGLE: {
      const data = action.payload;
    
      return {
        ...state,
        entities: {
          ...state.entities,
          [data.id]: data
        },
        ids: [
          ...state.ids,
          data.id as string
        ],
        loading: false
      };
    }

    case ActionTypes.FAILURE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
}

export default reducer;
